import { render, staticRenderFns } from "./ApproveOrder.vue?vue&type=template&id=ef68a6d4&scoped=true&"
import script from "./ApproveOrder.vue?vue&type=script&lang=js&"
export * from "./ApproveOrder.vue?vue&type=script&lang=js&"
import style0 from "./ApproveOrder.vue?vue&type=style&index=0&id=ef68a6d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef68a6d4",
  null
  
)

export default component.exports